var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[_c('v-main',[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('navBar'),_c('router-view',{staticClass:"mt-16"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }